export default function compareSubCategories(
  subCategoryPriorityA: number,
  subCategoryPriorityB: number,
  nameA: string,
  nameB: string,
): number {
  if (subCategoryPriorityA < subCategoryPriorityB) {
    return -1
  } else if (subCategoryPriorityA > subCategoryPriorityB) {
    return 1
  }
  return nameA < nameB ? -1 : 1
}
